<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">User Ip List</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#addNew">
                      <i class="fa fa-plus-square"></i>
                      Add New
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover" id="userIpList">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Date</th>
                      <th>Ip</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in ips" >
                     <!-- <tr v-for="ips in ips.data" :key="ip.id"> -->
                      <td>{{index}}</td>
                      <td>{{item.date_entered}}</td>
                      <td>{{item.ip}}</td>
                      <td>{{item.description}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Create New User ACL Ip </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="createUserIp">
                    <div class="modal-body">
                            <div class="form-group">
                                <label>Ip</label>
                                <input v-model="form.ip" type="text" name="ip"
                                    class="form-control" :class="{ 'is-invalid': form.errors.has('ip') }">
                                <has-error :form="form" field="ip"></has-error>
                            </div>
                             <div class="form-group">
                                <label>Descrition</label>
                                <input v-model="form.description" type="text" name="description"
                                    class="form-control" :class="{ 'is-invalid': form.errors.has('description') }">
                                <has-error :form="form" field="description"></has-error>
                            </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Create</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>

    import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.css';

    export default {
        data () {
            return {
              ips : {},
              form: new Form({
                  ip: '',
                  description:''
              })
            }
        },
        methods: {

          loadUsersIps(){
            axios.get("api/v1/ACLPanel").then(({ data }) => (this.ips = data.data));
          },
          createUserIp(){
              this.$Progress.start();

              this.form.post('api/v1/ACLPanelSave').then((data)=>{
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                  this.form.reset();
                  this.$Progress.finish();
                  this.loadUsersIps();

              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          }

        },
        updated: function() {
            this.$nextTick(function () {
                $('#userIpList').DataTable({
                    retrieve: true,
                    responsive: true,
                    "bDestroy": true,

                });
          })
        },
        mounted() {
            this.$Progress.start();

            this.loadUsersIps();

            this.$Progress.finish();
        },
        created() {
            this.$Progress.start();

            this.loadUsersIps();

            this.$Progress.finish();
        }
    }
</script>
